import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/client";

export const STUDENTS_LIST_KEY = {
  STUDENTS_LIST: "STUDENTS_LIST",
};

export const useStudentsLists = ({ page }: { page: number }) =>
  useQuery([STUDENTS_LIST_KEY.STUDENTS_LIST, page], () =>
    get({ url: "api/v1/students/students-list", params: { page } })
  );
